export function sendAnalytics({ excluded, path, referer, title, url } = {}) {
    const options = {
        ...(excluded && excluded.length && { excluded }),
        ...(path && { path }),
        ...(referer && { referer }),
        ...(title && { title }),
        ...(url && { url }),
    };
    /**
     * Отключена аналитика 01.06.2025 из за № 152-ФЗ
     */
    // this.$googleGtag({
    //   ...options,
    //   ...(url && { location: url }),
    // })
    this.$amberData(options);
    this.$liveInternet(options);
    this.$mailRu(options);
    this.$yandexMetrika.pageHit(options);
}
